import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableCell, TableBody, TableContainer, TableRow, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Tooltip, CircularProgress, InputLabel, Select, MenuItem } from "@material-ui/core"
import { regexConstants } from '../../../constants/regEx';

export default function ThrustField({ thurstInfo, onFieldChange, setError, error, llp }) {
    return (
        <TableContainer style={{margin:'5px'}}>
            <Table className='mui-table-format llp-thrust-table' aria-label="simple table" >
                <TableHead style={{ background: '#f0f2f3' }}>
                    <TableRow>
                        <TableCell>Thrust</TableCell>
                        <TableCell align="left">{llp?.is_hourly_based === true? "Operating Hours / Cycles" : "Operating Cycles"}</TableCell>
                        <TableCell align="left">{llp?.is_hourly_based === true ? "Hours / Cycle Limit" : "Cycle Limit"}</TableCell>
                        <TableCell align="left">{llp?.is_hourly_based === true ? "Remaining Hours / Cycles" :"Remaining Cycles"}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {thurstInfo?.map((row) => (
                        <TableRow key={row?.id}>
                            <TableCell> {row?.engine_thrust_name} </TableCell>
                            <TableCell>
                                <TextField
                                    variant="outlined"
                                    name="csn"
                                    margin="normal"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    keyParams="csn"
                                    id="csn"
                                    inputProps={{ maxLength: 15 }}
                                    onChange={(e) => regexConstants.numberWithDot.test(e.target.value)? onFieldChange('operated_cycles_thrusts', llp?.is_hourly_based === true ? "tsn" : 'csn', e.target.value, row?.id): e.preventDefault()}
                                    value={llp?.is_hourly_based === true ? llp?.operated_cycles_thrusts?.find(ele => ele.id == row?.id)?.tsn : llp?.operated_cycles_thrusts?.find(ele => ele.id == row?.id)?.csn ?? ''}
                                    />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    variant="outlined"
                                    onChange={(e) => regexConstants.numberWithDot.test(e.target.value)? onFieldChange('cycles_max_limit_thrusts','cycles_max_limit', e.target.value, row?.id): e.preventDefault()}
                                    margin="normal"
                                    fullWidth
                                    inputProps={{ maxLength: 15 }}
                                    InputLabelProps={{ shrink: true }}
                                    value={llp?.cycles_max_limit_thrusts?.find(ele => ele.id == row?.id)?.cycles_max_limit?? ''}
                                    />
                            </TableCell>
                            <TableCell>
                                <TextField variant="outlined"
                                    onChange={(e) => regexConstants.numberWithDot.test(e.target.value)? onFieldChange('cycles_remaining_thrusts','cycles_remaining', e.target.value, row?.id): e.preventDefault()}
                                    disabled
                                    margin="normal"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={llp?.cycles_remaining_thrusts?.find(ele => ele.id == row?.id)?.cycles_remaining?? ''}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
